/* eslint-disable */
import dayjs from 'dayjs'
import _ from 'lodash'

/* ---------------------------------유효성검사 START--------------------------------- */
/**
 * 핸드폰 번호 체크
 * '010-1234-5678'
 * @param number
 * @returns {boolean}
 */
export const checkPhoneNumber = number => {
    const regPhone = /^010-\d{4}-\d{4}$/
    return regPhone.test(number)
}
/**
 * 핸드폰 번호 유효성 검사
 * @param _ 해당 필드의 규칙을 나타내는 객체 (무시)
 * @param phone
 * @returns {Promise<never>|Promise<void>}
 */
export const validatePhoneNumber = (_, phone) => {
    if (!phone) {
        return Promise.reject(new Error('핸드폰 번호를 입력해주세요.'))
    }
    if (!checkPhoneNumber(phone)) {
        return Promise.reject(new Error('올바른 핸드폰 번호 형식이 아닙니다.'))
    }
    return Promise.resolve()
}

// 생년월일 유효성 검증
export const validateBirthDate = (rule, value, callback) => {
    if (!value) {
        callback('생년월일 6자리를 입력해주세요.')
    } else if (!/^\d{6}$/.test(value)) {
        callback('생년월일은 숫자 6자리여야 합니다.')
    } else {
        const year = parseInt(value.slice(0, 2), 10)
        const month = parseInt(value.slice(2, 4), 10)
        const day = parseInt(value.slice(4, 6), 10)

        // 임의로 1900년대를 기준으로 체크. (실제 구현 시 성별코드 등으로 판단 가능)
        const fullYear = year >= 0 && year <= 25 ? 2000 + year : 1900 + year

        const date = new Date(fullYear, month - 1, day)
        const isValid = date.getFullYear() === fullYear && date.getMonth() === month - 1 && date.getDate() === day

        if (!isValid) {
            callback('유효한 생년월일이 아닙니다.')
        } else {
            callback()
        }
    }
}
/**
 * 이메일 유효성 검증
 * @param rule
 * @param value
 * @param callback
 */
export const validateEmail = (rule, value, callback) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
    if (!value) {
        callback('이메일 주소를 입력해주세요.')
    } else if (!emailRegex.test(value)) {
        callback('올바른 이메일 주소를 입력해주세요.')
    } else {
        callback()
    }
}

/**
 * 비밀번호 유효성 검증
 * @param _ 해당 필드의 규칙을 나타내는 객체 (무시)
 * @param password
 * @returns {Promise<never>|Promise<void>}
 */
export const validatePassword = (_, password) => {
    if (!password) {
        return Promise.reject(new Error('비밀번호를 입력해주세요.'))
    }
    if (password.length < 6) {
        return Promise.reject(new Error('비밀번호는 6자 이상이어야 합니다.'))
    }
    // 영문과 숫자가 모두 포함되어야 함
    const hasLetter = /[a-zA-Z]/.test(password)
    const hasNumber = /[0-9]/.test(password)
    if (!hasLetter || !hasNumber) {
        return Promise.reject(new Error('비밀번호는 영문, 숫자 조합이어야 합니다.'))
    }
    return Promise.resolve()
}

/**
 * 비밀번호 확인 유효성 검증
 * @param form Form 인스턴스
 * @returns {Function}
 */
export const validatePasswordConfirm = form => (_, passwordConfirm) => {
    const password = form.getFieldValue('password')
    if (!passwordConfirm) {
        return Promise.reject(new Error('비밀번호 확인을 입력해주세요.'))
    }
    if (password !== passwordConfirm) {
        return Promise.reject(new Error('비밀번호가 일치하지 않습니다.'))
    }
    return Promise.resolve()
}

/**
 * 날짜 형식 검증 함수
 * @param {string} date - 검증할 날짜 값
 * @returns {boolean} - 날짜 형식이 올바르면 true, 아니면 false
 */
export const isValidDateFormat = date => {
    const dateRegex = /^\d{4}-\d{2}-\d{2}$/
    return dateRegex.test(date)
}

export const formatDateTime = dateTimeString => {
    const date = new Date(dateTimeString)
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')

    return `${year}-${month}-${day}`
}
/* ---------------------------------유효성검사 END--------------------------------- */

/* ---------------------------------포맷팅함수 START-------------------------------- */
/**
 * 지난달 첫 날짜 / 마지막 날짜 구하기
 * @returns {[dayjs.Dayjs,dayjs.Dayjs]}
 */
export const getLastMonthDates = () => {
    // 현재 날짜를 가져옵니다.
    const today = dayjs()

    // 저번달의 첫 날을 계산합니다.
    const lastMonthStart = today.subtract(1, 'month').startOf('month')

    // 저번달의 마지막 날을 계산합니다.
    const lastMonthEnd = lastMonthStart.endOf('month')

    return [lastMonthStart, lastMonthEnd]
}

/**
 * 이번달 첫 날짜 / 마지막 날짜 구하기
 * @returns {[dayjs.Dayjs,dayjs.Dayjs]}
 */
export const getCurrentMonthDates = () => {
    // 현재 날짜를 가져옵니다.
    const today = dayjs()

    // 이번 달의 첫 날을 계산합니다.
    const currentMonthStart = today.startOf('month')

    // 이번 달의 마지막 날을 계산합니다.
    const currentMonthEnd = today.endOf('month')

    return [currentMonthStart, currentMonthEnd]
}

/**
 * 천원 단위 콤마 컨버팅 함수
 * @param number
 * @returns {*}
 */
export const formatCurrency = number => {
    // Convert the number to a string
    if (!number) return 0
    const numString = number.toString()

    // Use regex to add commas
    const formattedNumber = numString.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    return formattedNumber
}

// 숫자를 1,000자씩 나오도록 포맷팅
export const formatNumberToThousands = value => {
    if (value) {
        const formattedValue = Number(value).toLocaleString('en-US')
        return formattedValue
    }
    return value
}

// 입력된 값에서 숫자 외의 문자 제거
export const numberParser = value => {
    return value.replace(/\D/g, '')
}

/**
 * 프로그램 운영 필터링
 * 예정/진행/완료
 * @param startDateStr
 * @param endDateStr
 * @returns {string}
 */
export const getStatus = (startDateStr, endDateStr) => {
    // 현재 날짜 가져오기
    const currentDate = new Date()

    // 문자열을 Date 객체로 변환
    const startDate = new Date(`${startDateStr.slice(0, 4)}-${startDateStr.slice(4, 6)}-${startDateStr.slice(6)}`)
    const endDate = new Date(`${endDateStr.slice(0, 4)}-${endDateStr.slice(4, 6)}-${endDateStr.slice(6)}`)

    // 예정, 진행, 완료 상태 판단
    if (currentDate < startDate) {
        return '예정'
    }
    if (currentDate <= endDate) {
        return '진행'
    }
    return '완료'
}

/**
 *
 * @param  item
 * @returns convertedData
 * 수혜학생 통계 엑셀 export conver
 */
const convertExcelColToKor = (item = []) => {
    const convertedData = {
        연도: item.year,
        지역: item.region,
        강사채용수: item.numberOfTrained,
        교육신청자수: item.numberOfApplicants,
        교육수혜자수: item.numberOfBenefited,
        수혜율: item.benefitedRatio,
        초등학교: item.elementSchool,
        중학교: item.middleSchool,
        고등학교: item.highSchool,
        특수학교: item.specialSchool,
        ...(item.year !== 2024 && {
            남성: item.male,
            여성: item.female,
            '미래채움센터 有': item.miraeCenterY,
            '미래채움센터 無': item.miraeCenterN,
        }),
        일반학생: item.regularStudents,
        소외계층: item.underprivileged,
        일반학교: item.regularSchool,
        도서벽지학교: item.islandSchool,
        ...(item.year !== 2024 && {
            도서벽지학교: item.islandSchool,
            '특수학교 (장애학교, 대안학교 등)': item.specialSchool2,
        }),
        '기관 (아동복지센터 등)': item.welfareCenter,
        '1-2시간': item['hour1to2'],
        '3-8시간 미만': item['hour3to8'],
        '8-30시간 미만': item['hour8to30'],
        '30-50시간 미만': item['hour30to50'],
        '50시간 이상': item.more50Hours,
        온라인: item.online,
        오프라인: item.offline,
        센터내교육: item.inCenterEdu,
        찾아가는교육: item.visitingEdu,
        기타: item.etc,
        찾아가는교육비율: item.visitingRatio,
    }
    return convertedData
}

export const convertExcelColumnToKor = item => {
    const convertedData = item && item.map(convertExcelColToKor)

    return convertedData
}

/**
 *
 * @param  item
 * @returns convertedData
 * 강사 통계 엑셀 export conver
 */
const convertTutorExcelColToKor = (item = []) => {
    const convertedData = {
        연도: item.year,
        지역: item.region,
        강사채용수: item.hiredCount,
        ...(item.year !== '2024' && {
            채용율: item.hiredRatio,
            '이탈인원 포함 합계': item.totalWithFail,
        }),
        신규강사: item.newEmployee,
        재고용강사: item.reemployee,
        청년: item.youth,
        경력단절여성: item.careerStopWoman,
        전문퇴직자: item.retiredExpert,
        '20~29세': item.age20s,
        '30~39세': item.age30s,
        '40~49세': item.age40s,
        '50대이상': item.ageOver50,
        남성: item.male,
        여성: item.female,
        ...(item.year !== '2024' && {
            '창업(사업자등록완료)': item.ownBussiness,
            정규직: item.fullTimeContract,
            계약직: item.contractWorker,
            '주 40시간 이상': item.over40week,
            '주 15 ~ 39시간': item.work15to39week,
            '주 15시간 미만': item.under15week,
            '4대보험 전부가입': item.fullInsurance,
            '4대보험 일부가입': item.partialInsurance,
            '4대보험 미가입': item.noInsurance,
            '정규직 (무기계약직)': item.indefineContract,
            '21개월~30개월(2차 재고용)': item.secondaryRecontract,
            '11개월~20개월(1차 재고용)': item.firstRecontract,
            '10개월 이내(최초고용)': item.firstContract,
            ICTSW관련전공: item.ictswY,
            ICTSW관련없음: item.ictswN,
            인문과학: item.humanityMajor,
            사회과학: item.socialScienceMajor,
            자연과학: item.naturalScienceMajor,
            공학: item.techMajor,
            예체능: item.artMajor,
            기타전공: item.etcMajor,
        }),
        'SW강의경험 없음': item.noSwExperience,
        ...(item.year !== '2024' && {
            'SW강의경험 1년 미만': item.swExperienceUnderYear,
            'SW강의경험 1년이상 3년미만': item.swExperienceOneToThree,
            'SW강의경험 3년이상': item.swExperienceOverThree,
        }),
        '기타 강의경험 없음': item.noLecExperience,
        ...(item.year !== '2024' && {
            '기타 강의경험 1년 미만': item.lecExperienceUnderYear,
            '기타 강의경험 1년이상 3년미만': item.lecExperienceOneToThree,
            '기타 강의경험 3년이상': item.lecExperienceOverThree,
            '강사 평균임금': item.averageWage,
        }),
    }
    return convertedData
}

export const convertTutorExcelColumnToKor = item => {
    const convertedData = item && item.map(convertTutorExcelColToKor)

    return convertedData
}

/**
 * 주민등록번호 계산
 * @param jumin
 * @returns {number|null}
 */
export const getAgeFromJumin = jumin => {
    // '-' 제거
    if (jumin?.includes('-')) {
        jumin = jumin.replace('-', '')
    }

    // 주민번호 앞 6자리만 들어온 경우 처리
    if (jumin?.length === 6) {
        // 생년월일만으로는 세기 판단 불가하므로 기본적으로 2000년 이후로 가정
        // 사용자가 선택한 성별코드나 추가정보가 있다면 보완 가능
        const juminFront = jumin
        const year = parseInt(juminFront.substr(0, 2), 10)
        const month = parseInt(juminFront.substr(2, 2), 10)
        const date = parseInt(juminFront.substr(4, 2), 10)

        // 2000년생으로 가정 후 계산
        const today = new Date()
        let birthDate = new Date(2000 + year, month - 1, date)

        // 현재보다 미래라면 1900년생으로 간주
        if (birthDate > today) {
            birthDate = new Date(1900 + year, month - 1, date)
        }

        let age = today.getFullYear() - birthDate.getFullYear()
        const monthCheck = today.getMonth() - birthDate.getMonth()
        if (monthCheck < 0 || (monthCheck === 0 && today.getDate() < birthDate.getDate())) {
            age--
        }

        return age
    }

    // 주민번호가 13자리가 아닌 경우
    if (jumin?.length !== 13) {
        // console.log('==================ERROR:주민등록번호 데이터 확인 필요')
        return false
    }

    // 이하 기존 전체 주민번호 처리 로직
    const today = new Date()
    const juminBackFirstVal = jumin.substr(6, 1)
    const juminMonth = jumin.substr(2, 2)
    const juminDate = jumin.substr(4, 2)

    let birthDate, juminYear, age, monthCheck

    if (['1', '2', '5', '6'].includes(juminBackFirstVal)) {
        juminYear = '19' + jumin.substr(0, 2)
    } else {
        juminYear = '20' + jumin.substr(0, 2)
    }

    birthDate = new Date(Number(juminYear), Number(juminMonth) - 1, Number(juminDate))
    age = today.getFullYear() - birthDate.getFullYear()
    monthCheck = today.getMonth() - birthDate.getMonth()

    if (monthCheck < 0 || (monthCheck === 0 && today.getDate() < birthDate.getDate())) {
        age--
    }

    return age
}

// 주민번호 성별 구별
export const getGenderFromResidentNumber = residentNumber => {
    const lastDigit = parseInt(residentNumber.charAt(7), 10)
    if (lastDigit % 2 === 1) {
        return '남'
    } else {
        return '여'
    }
}

/**
 * 정규표현식을 사용하여 괄호 및 괄호 내의 숫자 제거
 * @param str
 * @returns {*}
 */
export const removeParentheses = str => {
    return str.replace(/\(\d+\)/g, '').trim()
}

/* ---------------------------------포맷팅함수 END--------------------------------- */

/* ---------------------------------기타 START--------------------------------- */
/**
 * 인증 불필요 페이지 경로 상수
 */
export const PUBLIC_ROUTES = {
    LOGIN: '/login',
    TUTOR_LOGIN: '/tutor-login',
    TUTOR_SIGNUP: '/tutor-signup',
    TUTOR_FIND_PASSWORD: '/tutor-find-password',
}

/**
 * 강사 관련 공개 경로
 */
const TUTOR_PUBLIC_ROUTES = [PUBLIC_ROUTES.TUTOR_LOGIN, PUBLIC_ROUTES.TUTOR_SIGNUP, PUBLIC_ROUTES.TUTOR_FIND_PASSWORD]

/**
 * 인증이 필요없는 공개 페이지인지 확인
 * @param {string} pathname - 현재 경로
 * @returns {boolean} 공개 페이지 여부
 */
export const isPublicRoute = pathname => {
    return Object.values(PUBLIC_ROUTES).includes(pathname)
}

/**
 * 엑셀 대량 등록시
 * 빈칸/문자열/배열 데이터 예외처리
 * @param item
 * @returns {*}
 */
export const processItem = item => {
    let result
    if (typeof item === 'string') {
        result = [item]
    } else if (Array.isArray(item)) {
        result = item.split(',')
    } else {
        result = null
    }
    return result
}

/**
 * 작성자: 김승주
 * 설명: 특정 key 값이 중복된 객체 배열에서 중복을 제거하는 함수
 * @param {any[]} arr
 * @param {string} key
 */
export const formatUniqueArr = (arr, key) => {
    const ids = new Set()
    return arr.filter(item => {
        if (ids.has(item[key])) return false
        ids.add(item[key])
        return true
    })
}
/* ---------------------------------기타 END--------------------------------- */
